import React, { memo } from 'react';
import styles from './listNotFound.module.scss';
import { useTranslation } from 'react-i18next';


const ListNotFound = ({ className, title = null, subTitle = null }) => {
    const { t } = useTranslation('home');

    return (
        <div className={`${className} ${styles.listNotFound}`}>
            <div className={styles.title}>
                {title || t("home:there_are_no_records_to_show")}
            </div>
            <div className={styles.subTitle}>
                {subTitle || t("home:please_come_back_again_later")}
            </div>
        </div>
    );
}
export default memo(ListNotFound);